<template>
  <nav class="term-nav">
    <div class="term-nav__wrap">
      <router-link :to="{ name: 'group.overview' }" class="term-nav__item tag" :class="{ 'term-nav__item--active': selectedGroupTermId == null }">Overzicht</router-link>
      <router-link
        v-for="(term, index) in terms"
        :to="{ name: 'students.overview', params: { groupTermId: term.groupTermId } }"
        :key="'term-link-'+term.groupTermId"
        class="term-nav__item tag"
        :class="{ 'term-nav__item--active': selectedGroupTermId == term.groupTermId, 'term-nav__item--current': currentGroupTermId == term.groupTermId }">
        {{ index+1 }}. {{ term.title }}
      </router-link>
    </div>
  </nav>
</template>


<script>
export default {
    props: {
        terms: {
            type: Array,
            required: true,
        },
        selectedGroupTermId: {
            type: String,
            required: false,
            default: null,
        },
        currentGroupTermId: {
            type: String,
            required: false,
            default: null,
        }
    },
}
</script>

<style lang="scss">
    @import 'global';
    .term-nav {
      text-align: center;
      margin-bottom: 1em;

      &__wrap {
        padding: 0.2em 0.7em;
        margin: 0 auto;
        border-radius: 4px;
        border: 1px solid $color-lightest-grey;
        display: inline-block;
      }

      &__item {
        padding: 0.2em 0;
        margin: 0;
        color: $color-typography-light;

        &--current {
          text-decoration: underline;
        }

        &--active, &.router-link-active {
          color: $color-typography;
        }


        &:after {
          content: "";
          @include background-sprite-replace($arrow-forward-group);
          display: inline-block;
          margin: 1px 1em 4px;
          vertical-align: middle;
          opacity: 0.2;
        }

        &:last-child:after {
          content: none;
        }

      }

    }
</style>



// WEBPACK FOOTER //
// TermNav.vue?040ee3f3